export default "__VITE_ASSET__BO_KtBf4__"